import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useContext } from 'react';
import { BookerContext } from '../Booker/index.js';
import Field from '../Booker/components/Field.js';
import FieldContainer from '../Booker/components/FieldContainer.js';
import FieldButton from '../Booker/components/FieldButton.js';
import { useIntl } from 'react-intl';
const LoadingField = ({ className, children }) => {
    const { vertical, useTailwindPrefix } = useContext(BookerContext);
    return (_jsx(FieldContainer, Object.assign({ className: classNames({
            'md:w-4/12': !vertical && !useTailwindPrefix,
            'md:tw-w-4/12': !vertical && useTailwindPrefix,
        }, className), clipMargin: true, noBorder: true }, { children: children || (_jsx(Field, { children: _jsx("span", Object.assign({ className: classNames({
                    'text-transparent': !useTailwindPrefix,
                    'tw-text-transparent': useTailwindPrefix,
                }) }, { children: "_" })) })) })));
};
export const LoadingForm = () => {
    const intl = useIntl();
    const { vertical, useTailwindPrefix, version, inline, showLabels } = useContext(BookerContext);
    return (_jsx("div", Object.assign({ className: classNames({
            "before:content-[' '] before:table after:block after:content-[''] after:clear-both": !useTailwindPrefix,
            "before:tw-content-[' '] before:tw-table after:tw-block after:tw-content-[''] after:tw-clear-both": useTailwindPrefix,
        }) }, { children: _jsxs("div", Object.assign({ className: classNames({
                'flex flex-col min-w-[250px]': !useTailwindPrefix,
                'tw-flex tw-flex-col tw-min-w-[250px]': useTailwindPrefix,
                'md:flex-row': !vertical && !useTailwindPrefix,
                'md:tw-flex-row': !vertical && useTailwindPrefix,
                'itm-booker-form--regular': version !== 'padded',
                'itm-booker-form--padded md:px-widget-pill-padding-x md:py-widget-pill-padding-y md:border-widget-pill-border md:rounded-widget-pill-border-radius md:bg-widget-pill-background md:backdrop-blur': version === 'padded' && !useTailwindPrefix && !vertical,
                'itm-booker-form--padded md:tw-px-widget-pill-padding-x md:tw-py-widget-pill-padding-y md:tw-border-widget-pill-border md:tw-rounded-widget-pill-border-radius md:tw-bg-widget-pill-background md:tw-backdrop-blur': version === 'padded' && useTailwindPrefix && !vertical,
                'md:pb-widget-pill-padding-b': version === 'padded' && !vertical && showLabels && !useTailwindPrefix,
                'md:tw-pb-widget-pill-padding-b': version === 'padded' && !vertical && showLabels && useTailwindPrefix,
            }) }, { children: [_jsx(LoadingField, {}), _jsx(LoadingField, {}), _jsx(LoadingField, Object.assign({ className: classNames({
                        'md:hidden text-gray-200': !inline && !useTailwindPrefix,
                        'md:tw-hidden tw-text-gray-200': !inline && useTailwindPrefix,
                    }) }, (!inline && {
                    children: (_jsx("div", Object.assign({ className: "tw-text-[85%] tw-my-3 md:tw-mb-0" }, { children: intl.formatMessage({ id: `booker.promotion.question` }) }))),
                }))), _jsx(FieldContainer, Object.assign({ className: classNames({
                        'md:w-4/12': !vertical && !useTailwindPrefix,
                        'md:tw-w-4/12': !vertical && useTailwindPrefix,
                    }), clipMargin: true }, { children: _jsx(FieldButton, Object.assign({ type: "button", className: classNames({
                            'bg-transparent text-transparent border-gray-200': !useTailwindPrefix,
                            'tw-bg-transparent tw-text-transparent tw-border-gray-200': useTailwindPrefix,
                        }) }, { children: "_" })) }))] })) })));
};
